<template>
  <div id="app">
    <Top v-if="renderMenu" />
    <Intro
        @animation-ends="renderMenu = true"
    />
    <OurServices />
<!--    <Works />-->
    <Steps />
    <AboutMe />
<!--    <Advantages />-->
    <Order />
    <RFooter />
  </div>
</template>

<script>
import Top from './components/Top';
import Intro from './components/Intro';
// import Works from './components/Works';
import OurServices from './components/OurServices';
import Steps from './components/Steps';
// import Advantages from './components/Advantages';
import Order from './components/Order';
import RFooter from './components/RFooter';
import SmoothScroll from 'smooth-scroll';
import AboutMe from './components/AboutMe';

export default {
  name: 'app',
  components: {
    AboutMe,
    Top,
    Intro,
    // Works,
    OurServices,
    Steps,
    // Advantages,
    Order,
    RFooter
  },
  data() {
    return {
      renderMenu: false,
      scroller: null
    }
  },
  mounted() {
    this.scroller = new SmoothScroll('a[href*="#"]', {
      speed: 400,
      speedAsDuration: true,
      offset: () => 80
    });
  },
  methods: {}
}
</script>

<style lang="scss">
@import './assets/vars';

body {
  margin: 0;
  background: white;
}

* {
  box-sizing: border-box;
}

:fullscreen {
  background-color: #000;
}

#app {
  font-family: $font-primary;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1,
h2,
h3 {
  -webkit-margin-before: 0;
  margin-block-start: 0;
  -webkit-margin-after: 0;
  margin-block-end: 0;
  -webkit-margin-start: 0;
  margin-inline-start: 0;
  -webkit-margin-end: 0;
  margin-inline-end: 0;
}

h2 {
  margin: 0 auto;
  font-size: 42px;
  font-weight: 900;
  padding: 50px 60px;
  text-align: center;
}

a {
  color: $color-primary;
  text-decoration: none;
  font-weight: 700;
}

.red-button {
  display: inline-block;
  border-radius: 26px;
  color: $color-primary;
  background: white;
  border: 3px solid $color-primary;
  font-size: 16px;
  padding: 14px 20px;
  font-weight: 900;
  outline: none;
  cursor: pointer;

  &:hover {
    color: white;
    background: $color-primary;
  }

  &:disabled {
    opacity: 0.4;
  }
}

.red-input {
  font-size: 18px;
  font-weight: 400;
  font-family: $font-primary;
  /*border-radius: 32px;*/
  padding: 16px 0;
  line-height: 28px;
  outline: none;
  border: none;
  border-bottom: 3px solid $color-border;
}

/* Landscape phones and portrait tablets */
@media (max-width: 767px) {
  h2 {
    font-size: 28px;
    padding: 30px 20px;
  }
}
</style>
